<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0">
          菜单名称
        </span>
        <el-input v-model="search.menuName" placeholder="请输入菜单名称"></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span> 状态 </span>
        <el-select clearable v-model="search.status" placeholder="请选择状态">
          <el-option label="正常" :value="0"></el-option>
          <el-option label="禁用" :value="1"></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <el-button type="primary" size="medium" @click="getList">查询</el-button>
        <el-button size="medium" @click="resetForm">重置</el-button>
      </el-col>
    </el-row>
    <div class="m-b-10">
      <el-button type="primary" size="medium" @click="addOrgFun">+&nbsp;新增</el-button>
    </div>
    <el-table ref="checktableData" :data="tableDataList" v-loading="tableDataLoading" default-expand-all row-key="menuId"
      height="60vh">
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="addRowFun(scope.row)">新增</el-button>
          <el-button type="text" @click=editRowFun(scope.row)>编辑</el-button>
          <el-button type="text" @click=deleteRowFun(scope.row)>删除</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="menuName" label="菜单名称" min-width="120" align="center"></el-table-column>
      <el-table-column prop="orderNum" label="排序" min-width="200" align="center"></el-table-column>
      <el-table-column prop="path" label="路由地址" min-width="100" align="center"></el-table-column>
      <el-table-column prop="component" label="组件路径" min-width="100" align="center"></el-table-column>
      <el-table-column prop="menuType" label="菜单类型" min-width="100" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" min-width="100" align="center"></el-table-column>
    </el-table>
    <AddMenuDialog ref="addMenuDialogRef" :treeDataList="treeDataList" @opera-success="getList"></AddMenuDialog>
  </div>
</template>
<script>
import AddMenuDialog from './components/AddMenuDialog.vue';
export default {
  name: 'menuManage',
  components: {
    AddMenuDialog
  },
  data () {
    return {
      /**
       * tableDataLoading 表格数据加载是否完毕
       * tableDataList 表格数据
       * search 表单查询数据
       * tableDataTotalNum 表格数据总数
       * allSelectedIds 所有选中的数据
       * unSelectedIds 所有未选中的id
       */
      tableDataLoading: false,
      tableDataList: [],
      treeDataList: [],
      search: {
        menuName: '',
        status: ''
      },
      tableDataTotalNum: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取数据请求
    getList () {
      this.list = [];
      this.tableDataLoading = true;
      this.HttpService.get('/autoapp-recovery-server-auth/api/tbl-sys-menu/list', this.search).then(res => {
        this.tableDataLoading = false
        if (res.statusCode === 200) {
          this.tableDataTotalNum = res.total
          if (res.data.length === 0) {
            this.tableDataList = []
            let main = [
              {
                menuName: '主类目',
                menuId: '0',
                parentField: null,
                children: []
              }
            ]
            this.treeDataList = main
          } else {
            let resData = res.data || []
            // 表格数据
            let copyResData = this.toTree(resData)
            this.tableDataList = copyResData
            let main = [
              {
                menuName: '主类目',
                menuId: '0',
                parentField: null,
                children: copyResData
              }
            ]
            this.treeDataList = main
          }
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 重置查询
    resetForm (formName) {
      this.search = {
        menuName: '',
        status: ''
      }
    },
    // 创建组织
    addOrgFun () {
      this.$refs.addMenuDialogRef.openDialog('add')
    },
    // 新增目前菜单项组织
    addRowFun (row) {
      const menuId = row.menuId
      this.$refs.addMenuDialogRef.openDialog('add', menuId)
    },
    // 编辑
    editRowFun (row) {
      // console.log('===row===', row)
      let rowData = JSON.parse(JSON.stringify(row))
      this.$refs.addMenuDialogRef.openDialog('edit', rowData)
    },
    // 删除
    deleteRowFun (row) {
      // console.log('===row===', row)
      const menuId = row.menuId
      if (menuId) {
        this.$dialog({
          title: '温馨提示',
          content: '是否要删除，删除后不可以恢复！',
          cancel_buttton: '否',
          ok_buttton: '是',
          width: '400px',
          footBtn: 'card',
          dialogType: 'delete',
          onOk: () => {
            const url = '/autoapp-recovery-server-auth/api/tbl-sys-menu/remove'
            this.HttpService.delete(`${url}?menuId=${menuId}`, {}).then(res => {
              if (res.statusCode === 200) {
                this.$message.success('删除成功')
                this.getList()
              } else {
                const tipMsg = res.message || '删除出错'
                this.$message.error(tipMsg)
              }
            })
          },
          onCancel: () => {
            console.log('cancel');
          }
        })
      }
    },
    toTree (data) {
      let result = []
      //检测确定传递的值是否是一个 Array。是 Array，则为true; 否则为false。
      if (!Array.isArray(data)) {
        return result
      }
      //遍历数组,删除对象的某个属性
      data.forEach(item => {
        delete item.children;
      });
      //将传入的数据的每一个id作为变量名=数据变量
      let map = {};
      data.forEach(item => {
        map[item.menuId] = item
      })
      //循环数据
      data.forEach(item => {
        //找到map对象里面对应的参数名
        let parent = map[item.parentId]
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          result.push(item)
        }
      })
      return result
    }
  }
}
</script>


<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
  padding: 0 20px;

  span {
    min-width: 80px;
    text-align: right;
    padding-right: 16px;
    box-sizing: border-box;
  }
}

.row-bg {
  margin-bottom: 15px;
}

.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/menuManage.vue